<template>
  <ToolbarItemContainer
    :iconFile="handleIcon()"
    :title="handleTitle()"
    :needDialog="false"
    iconWidth='20px'
    iconHeight='20px'
    @onIconClick="onIconClick"
  >
    <div :class="['video-upload', !isPC && 'video-upload-h5']">
      <input
        ref="inputRef"
        :title="props.title || TUITranslateService.t('视频')"
        type="file"
        data-type="video"
        accept="video/*"
        @change="sendVideoInWeb"
      >
    </div>
  </ToolbarItemContainer>
</template>
<script lang="ts" setup>
import {
  TUIChatService,
  TUIStore,
  StoreName,
  IConversationModel,
  SendMessageParams,
  SendMessageOptions,
  TUITranslateService
} from '../../../../@aidesk/uikit-engine';
import vue from '../../../../adapter-vue';
import { isPC } from '../../../../utils/env';
import ToolbarItemContainer from '../toolbar-item-container/index.vue';
import videoIcon from '../../../../assets/video.svg';
import videoIconH5 from '../../../../assets/video_h5.svg'
import { isEnabledMessageReadReceiptGlobal, getTo } from '../../../../utils/utils';
import Log from '../../../../utils/logger';
import { Toast, TOAST_TYPE } from '../../../common/Toast/index-web';
const { ref } = vue;

const props = defineProps({
  // Video source, only valid for uni-app version, web version only supports selecting videos from files
  // album: Select from files
  // camera: Take a video using the camera
  videoSourceType: {
    type: String,
    default: 'album',
  },
  title: {
    type: String,
  },
});

const inputRef = ref();
const currentConversation = ref<IConversationModel>();

TUIStore.watch(StoreName.CONV, {
  currentConversation: (conversation: IConversationModel) => {
    currentConversation.value = conversation;
  },
});

const handleIcon = (): string => {
  return isPC ? videoIcon :  videoIconH5;
};

const handleTitle = (): string => {
  return props.title || TUITranslateService.t('视频');
};

const onIconClick = () => {
  inputRef?.value?.click && inputRef?.value?.click();
};

const sendVideoInWeb = (e: any) => {
  if (e?.target?.files?.length <= 0) {
    return;
  }
  const file = e?.target?.files[0];
  if (!file || !file.size) {
    return;
  }
  sendVideoMessage(e.target);
  e.target.value = '';
};

const sendVideoMessage = (file: any) => {
  if (!file) {
    return;
  }
  const options = {
    to: getTo(currentConversation?.value),
    conversationType: currentConversation?.value?.type,
    payload: {
      file,
    },
    needReadReceipt: isEnabledMessageReadReceiptGlobal(),
  } as SendMessageParams;
  const sendMessageOptions: SendMessageOptions = {};
  TUIChatService.sendVideoMessage(options, sendMessageOptions)
  .catch((err) => {
    Toast({
      message:
        err.code === 2351 ? 
          TUITranslateService.t('AIDesk.video 大小超过 100MB，无法发送') 
        : err.message,
      type: TOAST_TYPE.ERROR,
      duration: 5000,
    });
    Log.l(`Send Video Failed:${err.code} ${err.message}`);
  });
};
</script>

<style lang="scss" scoped>
@import "../../style/common";
</style>
